import ScriptHelper from "base/ScriptHelper";
import { svg_include } from "base/functions";

export default function handleGoogleMapBlocks() {
    let $elements = $('.js-google-map');

    $elements.each(function () {
        let map = this;
        let mapLoad = function () {
            loadGoogleMap($(map));
            map.removeEventListener('mouseover', mapLoad);
        }

        map.addEventListener('mouseover', mapLoad);
    });
}

export function loadGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyDK1GjlRGqbzQ8O_tHA2BLptx3SpDcXYno").then(() => {
        loadMap($element);
    });
}

function loadMap($element) {
    const type = $element.attr('data-type');

    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        styles: MAP_STYLES,
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    initMarker({lat: 51.820675, lng: -0.816043}, map, type);
    centerMap(map);
}

function initMarker(markerData, map, type) {

    let infowindow;
    let latLng = {
        lat: parseFloat(markerData.lat),
        lng: parseFloat(markerData.lng),
    };

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: {
            url: type === 'rehab-clinic' ? '/wp-content/themes/rbh-theme/images/svg/marker-purple.svg' : '/wp-content/themes/rbh-theme/images/svg/marker.svg',
            scaledSize: new google.maps.Size(45, 62),
            labelOrigin: new google.maps.Point(25, 69),
        },
    });

    marker.addListener('click', function () {
        if (infowindow) {
            infowindow.close();
        }

        let $content = (
            eotwJSXFactory('div', {className: "large-link--map shadow border--bottom"}, [
                eotwJSXFactory('div', {className: "large-link__content"}, [
                    eotwJSXFactory('p', {className: "heading heading--5"}, ["The Royal Buckinghamshire Hospital"]),
                    eotwJSXFactory('p', null, ["Buckingham Road,", eotwJSXFactory('br'),"Aylesbury,", eotwJSXFactory('br'),"Buckinghamshire,", eotwJSXFactory('br'),"HP19 9AB"]),
                    eotwJSXFactory('div', {className: "wp-block-buttons"}, [
                        eotwJSXFactory('a', {href: "https://www.google.com/maps/place/The+Royal+Buckinghamshire+Hospital/@51.8206171,-0.8160136,15z/data=!4m2!3m1!1s0x0:0xc9143cbc6322762d?sa=X&ved=2ahUKEwj05-DKmK2EAxVxQ0EAHWNSC1oQ_BJ6BAhhEAA", target: "_blank", className: "btn btn--link accent--turquoise"}, ["Get directions ", eotwJSXFactory('span', {className: "icon icon--arrow", unsafeHtml: svg_include('icon--arrow')})])
                    ])
                ])
            ])
        );

        infowindow = new google.maps.InfoWindow({
            content: $content[0],
        });

        infowindow.open(map, marker);
    });

    map.markers.push(marker);
}

function centerMap(map) {
    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
        });
    });

    if (map.markers.length === 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}

const MAP_STYLES = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#F5F5F5",
            },
        ],
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off",
            },
        ],
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161",
            },
        ],
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#F5F5F5",
            },
        ],
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#BDBDBD",
            },
        ],
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#EEEEEE",
            },
        ],
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575",
            },
        ],
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#E5E5E5",
            },
        ],
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9E9E9E",
            },
        ],
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#FFFFFF",
            },
        ],
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575",
            },
        ],
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#DADADA",
            },
        ],
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161",
            },
        ],
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9E9E9E",
            },
        ],
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#E5E5E5",
            },
        ],
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#EEEEEE",
            },
        ],
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#C9C9C9",
            },
        ],
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9E9E9E",
            },
        ],
    },
];
